import { css } from '../style-system';
/**
 * @param  {Parameters<css>} interpolatedStyles
 */

export function hover() {
  return css({
    '&:hover': css.apply(void 0, arguments)
  });
}
/**
 * @param  {Parameters<css>} interpolatedStyles
 */

export function active() {
  return css({
    '&:active': css.apply(void 0, arguments)
  });
}
/**
 * @param  {Parameters<css>} interpolatedStyles
 */

export function focus() {
  return css({
    '&:focus': css.apply(void 0, arguments)
  });
}